export enum OrderDetailSizeGridRowName {
  RequestedQuantity = 'requestedQuantity',
  ConfirmedQuantity = 'confirmedQuantity',
  DeliveredQuantity = 'deliveredQuantity',
  UnconfirmedQuantity = 'unconfirmedQuantity',
  UnitPriceNet = 'unitPriceNet',
  Count = 'Count',
}
export interface SizeGridRowConfig {
  rowId: OrderDetailSizeGridRowName;
  pathToSizeProperty: string;
}
